// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"147":"09f31030","655":"39987498","785":"8e867c63"}[chunkId] + ".chunk.js";
};